<!-- <textarea data-testid="auto-app-slider-notes-tab-textarea-1" name="notes" class="wc-form-control wc-textarea mb-3" [(ngModel)]="note" placeholder="Add your comment here" id="" cols="30" rows="5"></textarea> -->

<!-- <p><span class="mr-2  ats-cta-btn" title="Add notes"> </span> ADD NEW </p> -->
    <!-- <i class="fas fa-sticky-note f-12"
    (click)="openAddNOtesModal()"></i>  -->
    <div class="d-flex justify-content-between f-14 align-items-center mb-1">
        <span class="f-14 font-weight-600">Add New Notes </span>
        <button data-testid="auto-app-slider-notes-tab-button-1" (click)="openAddNOtesModal()" class="btn-trms-light">
            <i class="far fa-plus"></i> &nbsp;Add new
        </button>
    </div>

<!-- <button data-testid="auto-app-slider-notes-tab-button-2" class="ml-auto wc-btn bg-blue col-md-3 py-2 d-block" (click)="saveCandidateNote()">Save</button> -->
<p class="mb-3 text-9696 font-weight-500" style="margin-top: 10px;" *ngIf="candidatedata?.notes?.length">Notes History</p>
<p class="mt-1" *ngIf="!candidatedata?.notes?.length"> No notes available</p>
<div>
    <div class="onHover" *ngFor="let note of candidatedata?.notes">
        <div class="mb-2 d-flex align-items-start">
            <span class="mr-2">
                <span class="note-icon"><i class="fa-light fa-file"></i></span>
            </span>
            <div class="col-md-10 f-14" [innerHTML]=note?.note></div>
            <!-- <span>{{note.note}} </span> -->
    
        </div>
        <div class="text-right onhverEdit">

            <span class="mr-2  ats-cta-btn" *ngIf="note.isprivate == 0 || note.isprivate == 1 || (note.isprivate == 2 &&(isLoggedinUserIsAdmin || note.isactualcreator))" title="Edit note" (click)="editnotes(note)"> <i class="fas fa-edit f-12"
               ></i>
            </span>
            <span class="mr-2  ats-cta-btn" *ngIf="note.isprivate == 0 || note.isprivate == 1 || (note.isprivate == 2 &&(isLoggedinUserIsAdmin || note.isactualcreator))" title="Delete note" (click)="deletenote(note)"> <i class="fas fa-trash f-12"
               ></i>
            </span>
        </div>
        <div class="justify-content-end align-items-center f-12 text-9696 onhoverdisplay">
          {{note?.firstname}} {{note?.lastname}}  <i class="fas fa-circle f-10 mx-3" style="font-size: 4px;"
          ></i>
          {{note?.createdon | date: 'dd MMM yyyy'}}
          
        </div>
        <!-- <div *ngIf="note.isprivate == 1" class="justify-content-end align-items-center f-12 text-9696 onhoverdisplay">
            {{this.loggedinuserfirstname}} {{this.loggedinuserfirstname}}  <i class="fas fa-circle f-10 mx-3" style="font-size: 3px;"
            ></i>
            {{note?.createdon | date: 'dd MMM yyyy'}}
            
          </div> -->
        <hr class="my-3 ">
    </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
    <span class="successCheck"><i class="fal fa-check"></i> </span>
    <span class="successmsg">{{ successMessage }}</span>
  </ngb-alert>
  
  <ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
    <span class="errorCheck"><i class="fal fa-times"></i></span>
    <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<!-- <ng-template #successModal class="modal">
    <div class="modal-content">
      <div class="modal-body px-6 pb-6 pt-3">
        <div class="row mb-3">
          <div class="col pb-5">
            <button data-testid="auto-app-slider-notes-tab-button-3" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
              (click)="modalService.dismissAll()">
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col text-center">
            <img src="./../../../assets/images/success-vector.png" alt="img-fluid">
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <p class="text-center">CONGRATULATIONS !!!</p>
            <p class="text-center">{{statusMessage}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mx-auto d-flex">
            <button data-testid="auto-app-slider-notes-tab-button-4" class="col-md-4 mx-auto py-3 wc-ghostBtn" (click)="modalService.dismissAll()">CANCEL</button>
            <button data-testid="auto-app-slider-notes-tab-button-5" class="wc-btn bg-blue col-md-4 m-auto py-3" (click)="deletenotesmodal()">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template> -->

  <ng-template #successModal>
    <div class="modal-header b pb-0">
      <button data-testid="auto-app-slider-notes-tab-button-6" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pb-3 pt-0">
      <div class="row mb-3">
        <div class="col">
          <p>{{statusMessage}}
          <p>
        </div>
      </div>
      <div class="row">
        <div class="col d-flex justify-content-end">
          <button data-testid="auto-app-slider-notes-tab-button-7" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">No</button>
          <button data-testid="auto-app-slider-notes-tab-button-8" class="btn-trms-small" (click)="deletenotesmodal()">Yes</button>
        </div>
      </div>
    </div>
  </ng-template>

  <span class="mb-1 text-danger" *ngIf="((note?.dirty || note?.touched) && note?.errors && note?.errors?.htmlPresent)">Note cannot contain HTML tags as input. </span>